import $ from 'jquery'
import toastr from 'toastr'

window.jQuery = $
window.$ = $

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: true,
  positionClass: 'toast-top-right',
  preventDuplicates: true,
  showDuration: 300,
  hideDuration: 300,
  timeOut: 4000,
  extendedTimeOut: 1000,
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut'
}

export const toastService = {
  success(message, title = 'Succès') {
    toastr.success(message, title)
  },

  error(message, title = 'Erreur') {
    toastr.error(message, title)
  },

  info(message, title = 'Information') {
    toastr.info(message, title)
  },

  warning(message, title = 'Attention') {
    toastr.warning(message, title)
  }
}
